// @ts-ignore
import React from 'react';
import Head from 'next/head';
// @ts-ignore
import Main from '@components/Main';

const App = () => {

	return (
		<>
			<Head>
				<title>Login</title>
			</Head>
			<Main />
		</>
	);
};

export default App;
